export type{ iconType, IconProps } from "./Icon.interface";
export { Icon } from "./Icon";